import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { UtilityService } from '../../../../services/utility.service';

@Component({
  selector: '[account-settings-layout]',
  template: require('./account-settings-layout.component.pug'),
  styles: [require('./account-settings-layout.component.css').toString()],
})
export class AccountSettingsLayoutComponent {
  timeZoneCaching: Subscription;

  // -------------------------------------------------------------------
  constructor(
    private utilityService: UtilityService,

  ) {
    this.timeZoneCaching = this.utilityService
      .getTimeZones()
      .subscribe(res => {});
  }

  // -------------------------------------------------------------------
  ngOnInit() {}

  // -------------------------------------------------------------------
  ngOnDestroy(): void {
    if (this.timeZoneCaching) {
      this.timeZoneCaching.unsubscribe();
    }
  }

}
